<template>
  <ul id="chat-list" class="m-chat-list p-chat-list">
    <li class="u-msg item-time" v-if="canLoadMore">
      ---- {{$t('message.chat.pull')}} ----
    </li>
    <li class="u-msg item-time" v-else>
      ---- {{$t('message.chat.noMore')}} ----
    </li>
    
     <chat-item
                  v-for="(msg, index) in msglist"
                  :type="type"
                  :rawMsg="msg"
                  :isRobot="isRobot"
                  :userInfos="userInfos"
                  :myInfo="myInfo"
                  :key="(msg.idClient || index)"
                  :isHistory='isHistory'
                  @msg-loaded="msgLoaded"
                ></chat-item>
  </ul>
</template>
<script>
import ChatItem from './ChatItem'
import { List, Cell} from 'vant'

  export default {
    components: {
      ChatItem,
      [List.name]: List,
      [Cell.name]: Cell,
    },
    props: {
      type: String, // 类型，chatroom, session
      canLoadMore: [String, Boolean],
      isRobot: {
        type: Boolean,
        default () {
          return false
        }
      },
      msglist: {
        type: Array,
        default () {
          return []
        }
      },
      userInfos: {
        type: Object,
        default () {
          return {}
        }
      },
      myInfo: {
        type: Object,
        default () {
          return {}
        }
      },
      isHistory: {
        type: Boolean,
        default() {
          return false
        }
      }
      // robotInfos: {
      //   type: Object,
      //   default () {
      //     return {}
      //   }
      // }
    },
    data () {
      return {
        isFullImgShow: false,
        msgLoadedTimer: null,
        loading: false,
        finished: false

      }
    },
    methods: {
      showFullImg (src) {
        this.$store.dispatch('showFullscreenImg', {
          src
        })
      },
      msgLoaded () {
        clearTimeout(this.msgLoadedTimer)
        this.msgLoadedTimer = setTimeout(() => {
          this.$emit('msgs-loaded')
        }, 20)
      },
      onLoad (){

        this.finished = true
      }
    }
  }
</script>

<style lang="less" scoped>

 @import '../../assets/css/theme.less';
 
  .p-chat-list {
    .u-icon {
      width: 17.5px;
      height: 20px;
      margin-right: 2.5px;
      vertical-align: bottom;
    }
  }
   .m-chat-list {
      padding: 12.5px 2% 50px;
      width: 100%;
      overflow-y: scroll;
      overflow-x: hidden;
    }


    /*
* 元件
*/

  i {
    font-style: normal;
  }
  /* 白底输入框 */
  
  /* 消息记录 */
  .u-msg {
    position: relative;
    padding: 2.5px 0;
    &.session-chat {
      padding: 7.5px 0;
      clear: both;
    }
    /* 用户头像 */
    .msg-head {
      position: relative;
      display: inline-block;
      top: 1.25px;
      margin: 0;
      margin-right: 7.5px;
      margin-left: 7.5px;
      padding: 0;
      width: 25px;
      height: 25px;
      vertical-align: top;
      img {
        position: relative;
        display: inline-block;
        margin: 0;
        width: inherit;
        height: inherit;
      }
    }
    .msg-user {
      font-style: italic;
      color: #999;
      em {
        font-weight: normal;
        margin-right: 12.5px;
      }
    }
    .msg-audio img{
      float: right;
      margin-right: 3.75px !important;
    }
    .msg-text {
      position: relative;
      display: inline-block;
      max-width: 54%;
      min-height: 15px;
      word-break: break-word;
      height: auto;
      line-height: 15px;
      font-size: 11.25px;
      border: none;
      img {
        position: relative;
        display: inline-block;
        margin: 0;
        padding: 0;
        max-width: 100%;
        vertical-align: bottom;
        &.emoji-small {
          width: 17.5px;
          height: 17.5px;
          vertical-align: bottom;
        }
        &.emoji-big {
          width: 37.5px;
          height: 37.5px;
          vertical-align: middle;
        }
        &.emoji-big {
          width: 60px;
          height: 60px;
          vertical-align: middle;
        }
      }
      embed, video {
        position: relative;
        display: inline-block;
        max-width: 100%;
        max-height: 100px;
        vertical-align: bottom;
        background-color: #000;
        text-align: center;
        color: #fff;
      }
      &::before, &::after {
        content:' ';
        position: absolute;
        top: 10px;
        border-top: 5px solid transparent;
        border-bottom: 5px solid transparent;
        width: 0;
        height: 0;
      }
      &.notify {
        max-width: 100%;
      }
      .button {
        margin: 1.25px 0;
        padding: 1.25px 2.5px;
        border: 0.12px solid #fff;
        border-radius: 2.5px;
        background-color: @color_nav_active_background;
        color: #666;
      }
    }
    .msg-failed {
      position: relative;
      float: right;
      margin-right: 2.5px;
      vertical-align: top;
      font-size: 11.5px;
      line-height: 25px;
    }
    .msg-link {
      display: block;
      position: absolute;
      bottom: -25px;
      right: 0;
      min-width: 50px;
      min-height: 15px;
      word-break: normal;
      height: auto;
      line-height: 15px;
      font-size: 12.5px;
      border: none;
      a {
        color: @color_nav_active_font;
        text-decoration: underline;
        float: right;
      }
    }
    &.session-chat .msg-text {
      padding: 5px;
      margin-bottom: 10px;
      border-radius: 5px;
    }
    &.session-chat .msg-robot {
      min-width: 37.5px;
      margin-bottom: 37.5px;
    }
    &.session-chat.item-you {
      .msg-head, .msg-text {
        float: left;
      }
      .msg-text {
        background-color: @msg_bg_you;
        color: @msg_tx_you;
        &::before {
          right: 99%;
          border-right: 5px solid @msg_bg_you;
        }
        &::after {
          background: none;
        }
      }
    }
    &.session-chat.item-me {
      .msg-head, .msg-text {
        float: right;
      }
      .msg-text {
        color: @msg_tx_me;
        background-color: @msg_bg_me;
        &::before {
          background: none;
        }
        &::after {
          left: 99%;
          border-left: 5px solid @msg_bg_me;
        }
      }
    }
    &.item-time {
      font-size: 10px;
      text-align: center;
      color: @color_tip_font;
    }
    &.item-tip {
      font-size: 10px;
      text-align: center;
      .tip {
        margin: 0 auto;
        width: 125px;
        padding: 1.25px;
        background-color: @color_tip_background;
        border-radius: 5px;
      }
    }
    .notification {
      font-size: 10px;
      text-align: center;
      color: @color_tip_font;
    }
    .notify {
      color: #f50;
      font-size: 10px;
    }
  }
  .u-error {
    color: @color_error;
  }
  .u-icon {
    display: inline-block;
    width: inherit;
    height: inherit;
    &.icon-file {
      background-position: -95px -87.5px;
    }
  }
  .u-icon {
    background-size: 250px;
  }
  .u-icon-img {
    position: relative;
    width: inherit;
    height: inherit;
    img {
      position: relative;
      margin: 0;
      padding: 0;
      width: 100%;
      height: 100%;
    }
  }
  .u-circle {
    border-radius: 50%;
  }
  

</style>
